import { motion } from "framer-motion";

const VALUES = ["Love", "Leadership", "Accountability", "Protection", "Dedication"];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-24 md:py-32 bg-[#0b0d10] relative overflow-hidden border-y border-white/10"
    >
      <div className="absolute inset-0 grain-overlay opacity-[0.05]" />
      <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-[#e2562a]/10 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-7"
          >
            <span className="inline-flex items-center gap-3 text-[#e2562a] uppercase tracking-[0.35em] text-xs font-bold mb-6">
              <span className="h-px w-10 bg-[#e2562a]" />
              Our Commitment
            </span>
            <h2 className="font-display uppercase text-5xl md:text-7xl text-white leading-[0.92] tracking-tight">
              Stronger fathers.{" "}
              <span className="text-[#e2562a]">Stronger</span> families.
            </h2>
            <p className="mt-8 text-lg text-white/65 leading-relaxed max-w-xl">
              We are committed to reminding the world that real dads deserve love,
              support, appreciation, and the opportunity to thrive. Through
              outreach, mentorship, wellness, and family development, DADication
              helps fathers build legacies that outlast them.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7, delay: 0.15 }}
            className="lg:col-span-5"
          >
            <div className="border border-white/10 p-8 md:p-10 bg-[#16191e]">
              <p className="text-white/40 uppercase tracking-[0.25em] text-xs font-bold mb-6">
                Rooted in
              </p>
              <ul className="space-y-5">
                {VALUES.map((v, i) => (
                  <li
                    key={v}
                    className="flex items-baseline gap-4 border-b border-white/10 pb-4 last:border-0 last:pb-0"
                  >
                    <span className="font-display text-[#e2562a] text-xl w-8">
                      0{i + 1}
                    </span>
                    <span className="font-display uppercase text-2xl md:text-3xl text-white tracking-wide">
                      {v}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
